import React, { useState } from "react";
import { Description as DescriptionIcon } from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import UploadSoeTableModal from "./upload.soe.table.modal";

export default function UploadSoeTable({
  studyId,
  scheduleId,
}) {
  const [fileUploadOpen, setFileUploadOpen] = useState(false);

  const handleFileUploadClose = () => {
    setFileUploadOpen(false);
    // Remove the page refresh here
  };

  const handleFileUploadContinue = () => {
    setFileUploadOpen(false);
    window.location.reload(); // Refresh the page only when "Continue" is clicked
  };

  return (
    <Container>
      <Tooltip title="Upload SOE" arrow>
        <span>
          <StyledIconButton data-testid="upload-soe-button" onClick={() => setFileUploadOpen(true)}>
            <DescriptionIcon/>
          </StyledIconButton>
        </span>
      </Tooltip>
      {fileUploadOpen && (
        <UploadSoeTableModal
          open={fileUploadOpen}
          onClose={handleFileUploadClose}
          onContinue={handleFileUploadContinue}
          studyId={studyId}
          scheduleId={scheduleId}
        />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledIconButton = styled(IconButton)`
  color: var(--teal-700) !important;
  padding: 8px !important;
  
  &:hover {
    background-color: var(--teal-100) !important;
  }
  
  & .MuiSvgIcon-root {
    font-size: 1.5rem !important;
    width: 1.5rem !important;
    height: 1.5rem !important;
  }
`;
